var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-btn ui-btn-contribute",on:{"click":_vm.handleClick}},[_c('i',{staticClass:"icon-contribute"}),_c('span',[_vm._v("立即报名")])])}
var staticRenderFns = []

export { render, staticRenderFns }